module.exports = __webpack_public_path__ + "img/left.1fc90943.png";